<template>
  <div class="app-card inbox">
    <v-navigation-drawer
      temporary
      absolute
      v-model="inboxSidebar"
      :width="225"
    >
      <detalle-menu
        v-on:cambiarSeccion="cambiarSeccion"
        v-bind:usuario="usuarioSeleccionado"
      ></detalle-menu>
    </v-navigation-drawer>
    <v-layout
      row
      wrap
    >
      <v-flex
        xs12
        sm4
        md3
        lg3
        xl2
        class="inbox-sidebar"
      >
        <detalle-menu
          v-on:cambiarSeccion="cambiarSeccion"
          v-bind:usuario="usuarioSeleccionado"
        ></detalle-menu>
      </v-flex>
      <v-flex
        xs12
        sm12
        md9
        lg9
        xl10
        class="inbox-content"
      >
        <div class="inbox-content-wrap">
          <template>
            <div class="inbox-page-list d-custom-flex justify-space-between align-items-center primary">
              <div class="d-custom-flex align-items-center">
                <div class="ham-menu-sm d-none">
                  <v-btn
                    flat
                    icon
                    class="mr-3 my-0"
                    @click="toggleInboxSidebar"
                  >
                    <v-icon class="grey--text">menu</v-icon>
                  </v-btn>
                </div>

              </div>

            </div>
            <div
              class="inbox-listing grey lighten-3"
              style="min-height:500px;"
            >

              <template v-if="seccionSeleccionada">
                <component
                  v-bind:is="seccionSeleccionada.componente"
                  v-bind="seccionSeleccionada.props"
                >
                </component>
              </template>
              <v-spinner v-else></v-spinner>
            </div>
          </template>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import DetalleUsuario from './DetalleUsuario'
import DetallePersona from './DetallePersona'
import DetalleArchivos from './DetalleArchivos'
import DetalleRecetas from '@/modules/pacientes/pacientes/components/Detalle/DetalleRecetas'
import DetalleEstudios from '@/modules/pacientes/pacientes/components/Detalle/DetalleEstudios'
import DetalleMenu from './DetalleMenu'
import Usuario from '@/api/usuario'
import Paciente from '@/api/paciente'
import Estudio from '@/api/estudio'

export default {
  components: {
    DetalleMenu
  },
  computed: {
    usuarioSeleccionado () {
      return this.$store.getters['detalleUsuario/usuarioSeleccionado']
    },
    editando () {
      return this.$store.getters['detalleUsuario/editando']
    },
    cargando () {
      return this.$store.getters['detalleUsuario/cargando']
    }
  },
  props: {
    id: {
      type: Number,
      required: true
    },
    origen: {
      type: String,
      required: true
    },
    operacion: {
      type: String,
      default: 'modif'
    }
  },
  data () {
    return {
      inboxSidebar: false,
      alerta: {
        mostrar: false,
        tipo: 'error',
        mensaje: null
      },
      scrollbarSettings: {
        maxScrollbarLength: 160
      },
      seccionSeleccionada: null,
      secciones: {
        usuario: {
          mostrar: true,
          titulo: 'Datos de usuario',
          componente: DetalleUsuario,
          props: {
            id: this.id,
            operacion: this.operacion,
            permiso: this.origen === 'abm' ? 'admin_usuarios' : 'gral_perfil',
            modeloApi: Usuario,
            origen: this.origen
          }
        },
        persona: {
          mostrar: true,
          titulo: 'Datos personales',
          componente: DetallePersona,
          props: {
            id: this.id,
            operacion: this.operacion,
            permiso: this.origen === 'abm' ? 'admin_usuarios' : 'gral_perfil',
            modeloApi: Usuario

          }
        },
        archivo: {
          mostrar: true,
          titulo: 'Mis archivos',
          componente: DetalleArchivos,
          props: {
            id: this.id,
            operacion: this.operacion,
            permiso: this.origen === 'abm' ? 'admin_usuarios' : 'gral_perfil',
            modeloApi: Usuario

          }
        },
        receta: {
          mostrar: true,
          titulo: 'Recetas',
          componente: DetalleRecetas,
          props: {
            id: this.id,
            operacion: this.operacion,
            permiso: 'pacientes_recetas',
            modeloApi: Paciente

          }
        },
        estudio: {
          mostrar: true,
          titulo: 'Estudios',
          componente: DetalleEstudios,
          props: {
            id: this.id,
            operacion: this.operacion,
            permiso: 'pacientes_estudios',
            modeloApi: Estudio

          }
        }
      }
    }
  },
  mounted () {
    const contentWrapper = document.querySelector('.v-content__wrap')
    if (contentWrapper) {
      contentWrapper.style.overflow = 'hidden'
    }
    const selector = document.querySelector('.app-boxed-layout .app-content')
    if (selector) {
      selector.style.overflow = 'hidden'
    }
    this.$store.dispatch('detalleUsuario/obtenerUsuario', { id: this.id }).then(() => {
      this.$store.commit('persona/setearPersona', this.usuarioSeleccionado.persona)
      this.cambiarSeccion('usuario')
    })
  },
  destroyed () {
    this.$store.commit('detalleUsuario/setearUsuario')
    const contentWrapper = document.querySelector('.v-content__wrap')
    if (contentWrapper !== null) {
      contentWrapper.style.overflow = 'auto'
    }
    const selector = document.querySelector('.app-boxed-layout .app-content')
    if (selector) {
      selector.style.overflow = 'auto'
    }
  },
  methods: {
    cambiarSeccion (seccion) {
      if (this.usuarioSeleccionado) {
        let seccionSeleccionada = this.secciones[seccion]

        this.seccionSeleccionada = seccionSeleccionada
      }
    },

    toggleInboxSidebar () {
      this.inboxSidebar = !this.inboxSidebar
    },

    puedoEditar () {
      let permiso = this.origen === 'abm' ? 'admin_usuarios' : 'gral_perfil'
      return !this.editando && this.$puedo(permiso + ':modif')
    },

    editar () {
      this.$store.dispatch('detalleUsuario/editar', true)
    }

  }

}

</script>

<style lang="scss" scoped>
</style>
